import { useEffect as i } from "react";
import { g as f } from "./_commonjsHelpers-OnjxAlhP.js";
const m = (r, e) => {
  i(() => {
    var s, o;
    const t = (o = (s = f()) == null ? void 0 : s.document) == null ? void 0 : o.body;
    return r ? t == null || t.classList.add(e) : t == null || t.classList.remove(e), () => {
      t == null || t.classList.remove(e);
    };
  }, [r, e]);
};
export {
  m as u
};
